const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/** Resolve API-relative media paths (e.g. avatar URLs) for img src. */
export function mediaUrl(path) {
    if (!path) return null;
    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
        return path;
    }
    return `${BACKEND}${path}`;
}

export function userInitials(name) {
    if (!name) return "U";
    return name
        .split(" ")
        .map((part) => part[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
}
